var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loader',{attrs:{"active":!_vm.isLoaded,"assetLoaded":true},on:{"loader-end":_vm.loadFinish}}),_c('Navigation',{attrs:{"paths":_vm.routes}}),_c('Wrapper',[_c('Cover'),_c('PageList',[_c('Jobs'),_c('Education'),_c('Skills'),_c('Portfolio'),_c('Contacts')],1),_c('BgPattern',{attrs:{"active":_vm.isLoaded}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b17e643a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/assets/js/containers/Root/index.vue
// module id = YMoW
// module chunks = 2